import React from "react";
import PropTypes from "prop-types";

const PropertyFeatures = ({ propertyDetails }) => {
  // If no propertyDetails is provided, use sample data
  const featureData = propertyDetails || {
    cephe: ["Batı", "Güney"],
    icOzellikler: [
      "Alarm",
      "Ankastre Mutfak",
      "Kablo TV",
      "Parke Zemin",
      "Sauna",
    ],
    disOzellikler: ["24 Saat Güvenlik", "Isı Yalıtımı", "Jeneratör"],
    muhit: ["Alışveriş Merkezi", "Hastane", "Okul"],
    ulasim: ["Tramvay", "Otobüs Durağı", "Dolmuş"],
    manzara: ["Şehir"],
  };

  // Category titles in Turkish for display
  const categoryTitles = {
    cephe: "Cephe",
    icOzellikler: "İç Özellikler",
    disOzellikler: "Dış Özellikler",
    muhit: "Muhit",
    ulasim: "Ulaşım",
    manzara: "Manzara",
  };

  // Icon mapping for categories
  const categoryIcons = {
    cephe: "fa-compass",
    icOzellikler: "fa-home",
    disOzellikler: "fa-building",
    muhit: "fa-map-marker",
    ulasim: "fa-bus",
    manzara: "fa-image",
  };

  // Colors for feature items
  const categoryColors = {
    cephe: "#00519a",
    icOzellikler: "#00519a",
    disOzellikler: "#00519a",
    muhit: "#00519a",
    ulasim: "#00519a",
    manzara: "#00519a",
  };

  return (
    <div className="mt-5">
      <h4 className="mb-4">Özellikler</h4>

      <div className="row">
        {Object.keys(featureData).map(
          (category) =>
            featureData[category] &&
            featureData[category].length > 0 && (
              <div className="col-lg-12 mb-4" key={category}>
                <div className="feature-category">
                  <div
                    className="feature-header"
                    style={{ borderColor: categoryColors[category] }}
                  >
                    <div
                      className="feature-icon"
                      style={{ backgroundColor: categoryColors[category] }}
                    >
                      <i className={`fa ${categoryIcons[category]}`}></i>
                    </div>
                    <h5 className="feature-title">
                      {categoryTitles[category]}
                    </h5>
                  </div>

                  <div className="feature-content">
                    <div className="row">
                      {featureData[category].map((feature, index) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 mb-3"
                          key={index}
                        >
                          <div
                            className="feature-item"
                            style={{
                              borderLeft: `3px solid ${categoryColors[category]}`,
                            }}
                          >
                            <span className="feature-check">
                              <i className="fa fa-check"></i>
                            </span>
                            <span className="feature-text">{feature}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

// Define PropTypes for the component
PropertyFeatures.propTypes = {
  propertyDetails: PropTypes.shape({
    cephe: PropTypes.arrayOf(PropTypes.string),
    icOzellikler: PropTypes.arrayOf(PropTypes.string),
    disOzellikler: PropTypes.arrayOf(PropTypes.string),
    muhit: PropTypes.arrayOf(PropTypes.string),
    ulasim: PropTypes.arrayOf(PropTypes.string),
    manzara: PropTypes.arrayOf(PropTypes.string),
  }),
};

// Define default props
PropertyFeatures.defaultProps = {
  propertyDetails: {
    cephe: [],
    icOzellikler: [],
    disOzellikler: [],
    muhit: [],
    ulasim: [],
    manzara: [],
  },
};

export default PropertyFeatures;
